import { buildItemObsPayload } from 'utils/multiHallazgo';
import {
  buildResolucionesPayload,
  buildResolucionesEliminadasPayload,
} from 'utils/arrastrePrevios';

// Construye el payload del PUT /mantenciones/:id a partir de un draft del
// checklist offline. Espejo EXACTO de la lógica de `MaintanceToDoProvider.save()`:
// si esa cambia el shape del PUT, actualizar acá también.
//
// Decisiones sobre hallazgos previos: los "Resuelto" viajan en
// `resolucionesHallazgos`; los "Sigue presente" NO — viajan como la incidencia
// arrastrada del ítem (con `idHallazgoPrevio`), que el backend encadena. Mandarlos
// por los dos caminos duplicaría el hallazgo. Las decisiones ya guardadas que el
// técnico deshizo viajan en `resolucionesEliminadas` (ver arrastrePrevios.js).
export function buildMantencionPayload(draft) {
  const {
    estados,
    problems,
    observaciones,
    obsSug,
    ascensoresEstados,
    decisionesPrevios,
    decisionesEliminadas,
  } = draft || {};

  const formatedProblems = {};
  if (problems) {
    for (const key in problems) {
      const items = problems[key];
      const result = [];
      items?.forEach((item) => {
        const image = item?.image;
        if (Array.isArray(image) && image.length > 0) {
          result.push({
            ...item,
            image: image[0].existing ? image[0].url : image[0].response.path,
          });
        } else {
          result.push(item);
        }
      });
      formatedProblems[key] = result;
    }
  }

  const resoluciones = buildResolucionesPayload(decisionesPrevios);
  const eliminadas = buildResolucionesEliminadasPayload(decisionesEliminadas);

  return {
    items: estados,
    problems: formatedProblems,
    mantencionData: observaciones ? { observaciones } : null,
    itemObs: buildItemObsPayload(obsSug),
    ascensoresEstados: ascensoresEstados,
    ...(resoluciones.length > 0 ? { resolucionesHallazgos: resoluciones } : {}),
    ...(eliminadas.length > 0 ? { resolucionesEliminadas: eliminadas } : {}),
  };
}
